import React from 'react'
import { BreadcrumbsPDP } from './BreadcrumbsPDP'
import { BreadcrumbsPLP } from './BreadcrumbsPLP'
import { useTranslation } from 'next-i18next'

export type CategoryBreadcrumb = {
    category_name: string
    category_url_key: string
    category_url_path: string
}

interface BreadcrumbsProps {
    separator?: string
    rootText?: string
    rootTextVal?: string
    urlSuffix?: string
    urlPrefix?: string
}

interface CategoryBreadcrumbsProps extends BreadcrumbsProps {
    category: {
        name: string
        breadcrumbs?: CategoryBreadcrumb[]
    }
    product?: never
}

export type RequiredCategoryBreadcrumbsProps = Required<
    Omit<CategoryBreadcrumbsProps, 'product'>
>

export type ProductCategory = {
    name: string
    url_path: string | null
    breadcrumbs?:
        | {
              category_id: null
              category_name: string
              category_url_path: string | null
              category_uid: string
              __typename: string
          }[]
        | undefined
        | null
}[]
interface ProductBreadcrumbsProps extends BreadcrumbsProps {
    product: {
        name: string
        categories: ProductCategory
        primary_category?: {
            name: string
            url_path: string
        }
    }
    category?: never
}

export type RequiredProductBreadcrumbsProps = Required<
    Omit<ProductBreadcrumbsProps, 'category'>
>

export const Breadcrumbs = ({
    rootText = 'Home',
    separator = '/',
    urlSuffix = '',
    urlPrefix = '/category',
    category,
    product
}: CategoryBreadcrumbsProps | ProductBreadcrumbsProps): JSX.Element | null => {
    const { t } = useTranslation(['common'])
    const rootTextVal = t(`breadcrumbs|${rootText}`)
    const breadcrumbProps = {
        rootText,
        rootTextVal,
        separator,
        urlSuffix,
        urlPrefix,
        category,
        product
    }

    if (category)
        return (
            <BreadcrumbsPLP
                {...(breadcrumbProps as RequiredCategoryBreadcrumbsProps)}
            />
        )

    if (product)
        return (
            <BreadcrumbsPDP
                {...(breadcrumbProps as RequiredProductBreadcrumbsProps)}
            />
        )

    return null
}
